import { Component, EventEmitter } from '@angular/core';
import { Modal, ModalDismissReasons } from '../modal';
import { DialogOptions } from './dialog-options.model';
import { RebirthNGConfig } from '../rebirth-ng.config';

@Component({
  selector: 're-alert-dialog',
  template: "\n    <div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"no()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">{{context.title}}</h4></div><div class=\"modal-body\"><div *ngIf=\"!context.html\"><div *ngIf=\"context.icon\" class=\"dialog-icon\"><i class=\"{{context.icon}}\"></i></div><div class=\"dialog-content\">{{context.content}}</div></div><div *ngIf=\"context.html\"><div *ngIf=\"context.icon\" class=\"dialog-icon\"><i class=\"{{context.icon}}\"></i></div><div class=\"dialog-content\" [innerHTML]=\"context.content\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-{{btnYesType}}\" (click)=\"yes()\">{{context.yes || btnYes}}</button></div>\n  ",
  styles: ["\n    .dialog-icon{display:table-cell;vertical-align:middle;padding:1rem}.dialog-content{display:table-cell;vertical-align:middle}\n  "],
})
export class AlertDialogComponent implements Modal {
  context: DialogOptions;
  dismiss: EventEmitter<any>;
  btnYes: string;
  btnYesType: string;

  constructor(private rebirthNGConfig: RebirthNGConfig) {
    this.btnYes = rebirthNGConfig.dialog.button.yes;
    this.btnYesType = rebirthNGConfig.dialog.button.btnYesType;
  }

  yes() {
    this.dismiss.emit(ModalDismissReasons.YES);
  }

  no() {
    this.dismiss.error(ModalDismissReasons.NO);
  }
}
